"use client";

import { useCart } from "@trydig/centra/client";
import type { BaseSelectionItem } from "@trydig/centra-types/selection";
import { clsx } from "@trydig/ui";
import type { ComponentProps } from "react";
import {
	CartItem,
	CartItemSkeleton,
} from "@/features/cart/components/CartItem";
import styles from "./CartItems.module.css";

export interface CartItemsProps extends ComponentProps<"div"> {}

export const CartItems = ({ className, ...rest }: CartItemsProps) => {
	const { data, isLoading, error } = useCart();

	if (isLoading) {
		return <CartItemsSkeleton />;
	}

	if (error) {
		return null;
	}

	return <CartItemList items={data?.items || []} {...rest} />;
};

export const CartItemList = ({
	items,
	className,
	isStatic,
	...rest
}: CartItemsProps & {
	items: BaseSelectionItem[];
	isStatic?: boolean;
}) => {
	return (
		<div className={clsx(styles.root, className)} {...rest}>
			{items?.map((item) => {
				return <CartItem isStatic={isStatic} key={item.item} item={item} />;
			})}
		</div>
	);
};

export const CartItemsSkeleton = ({ size = 4 }: { size?: number }) => {
	return (
		<div className={styles.root}>
			{Array.from({ length: size }).map((_, i) => (
				<CartItemSkeleton key={i} />
			))}
		</div>
	);
};
